import { ICustomer } from 'types/customer.type';
import httpRequest from 'helpers/httpRequest';

export async function getMyInfo(): Promise<ICustomer> {
  const res = await httpRequest.get('/customer/me');

  return res.data.payload
}